"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxRow = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var checkbox_input_1 = require("../checkbox-input");
var flexbox_1 = require("../flexbox");
var padding_1 = require("../padding");
var text_1 = require("../text");
function CheckboxRow(props) {
    var _a;
    var id = props.id, label = props.label, isActive = props.isActive, disabled = props.disabled, onClick = props.onClick, count = props.count, _b = props.style, style = _b === void 0 ? {} : _b, propTestId = props.testId;
    var testId = (_a = propTestId !== null && propTestId !== void 0 ? propTestId : id) !== null && _a !== void 0 ? _a : (0, kebabCase_1.default)(label);
    return (react_1.default.createElement(flexbox_1.Flexbox, { style: style },
        react_1.default.createElement(checkbox_input_1.CheckboxInput, { id: id, testId: testId, checked: isActive, onChange: function (e) {
                onClick(e.target.checked);
            }, disabled: disabled }),
        react_1.default.createElement(padding_1.Padding, { left: 8, right: 4 },
            react_1.default.createElement("label", { htmlFor: id },
                react_1.default.createElement(text_1.Text, { style: {
                        pointer: 'cursor',
                    }, color: disabled ? 'light' : 'default' }, label))),
        count ? react_1.default.createElement(text_1.Text, { color: "light" },
            "(",
            count,
            ")") : null));
}
exports.CheckboxRow = CheckboxRow;
//# sourceMappingURL=index.js.map